import React from 'react'
import Announcements from './Announcements'
import BuildWithAI from './BuildWithAI'
// import './style.css'

const Homepage = (props) => (
  <div className="user-dashboard-page">
    <Announcements/>
    <BuildWithAI/>
  </div>
);

export default Homepage;

